import React from "react";
import PropTypes from "prop-types";
import styles from "./Loader.module.scss";

const Ripple = ({ radius, strokeWidth, className }) => {
  return (
    <circle
      cx={radius + strokeWidth}
      cy={radius + strokeWidth}
      strokeWidth={strokeWidth}
      fill="transparent"
      className={`${styles.animLoaderRipple} anim-infinite anim-duration-2000 anim-timing-ease-out ${className}`}
    />
  );
};

Ripple.propTypes = {
  className: PropTypes.string.isRequired,
  radius: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number.isRequired,
};

export default Ripple;
